import { Component, Input, WritableSignal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouteFormResult } from '@features/planification-map/components/route-form/models/routeRequestResults.model';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoPipe } from '@ngneat/transloco';
import { CoreService } from '@core/services';
import { UtilsService } from '@shared/services/utils.service';

@Component({
  selector: 'app-route-results-header',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, TranslocoPipe],
  templateUrl: './route-results-header.component.html',
  styleUrls: ['./route-results-header.component.scss']
})
export class RouteResultsHeaderComponent {

  @Input({required: true}) routeFormResults!: WritableSignal<RouteFormResult|null>;
  private coreService = inject(CoreService);
  public isMobile= inject(UtilsService).isMobile;

  public closeResults() {
    this.coreService.cleanAllItinerariesSearch();
  }

  public shareButtonClicked() {
    this.coreService.shareRouteByUrl();
  }


}
